<template>
  <div><slot></slot></div>
</template>

<script>
export default {
  // Options / Data
  data() {
    return {};
  },
  props: [],
  computed: {},
  name: 'table-animation'
  // methods: {},
  // watch: {},
  // Options / Lifecycle Hooks
  // mounted () {},
  // beforeDestroy () {},
  // Options / Assets
  // components: {},
  // transitions: {},
  // Options / Misc
  // mixins: [],
};
</script>
